const SignDataDto = {
	address: "",
	createdDate: new Date(),
	createdName: "",
	createdOrgName: "",
	createdRankName: "",
	email: "",
	id: null,
	isActive: true,
	isDelete: false,
	modifiedName: "",
	modifiedate: new Date(),
	numberDownload: 0,
	numberPrint: 0,
	numberSign: 0,
	numberView: 0,
	orgName: "",
	phoneNumber: "",
	rankName: "",
	requestData: null,
	signDate: new Date(),
	signName: "",
	signTypeCode: "",
	signTypeName: "",
	signature: "",
	signatureInfomation: null,
	status: null,
	userInfo: null,
};
export default SignDataDto;
